export default __webpack_public_path__ + "static/media/brac3.f1638193.jpg";